module.exports = __webpack_public_path__ + "static/img/icon8.a82f860.png";


//////////////////
// WEBPACK FOOTER
// ./src/view/fxcp_result/images/icon8.png
// module id = wWvI
// module chunks = 21